import { HttpParams } from '@angular/common/http';

export type ArrayFormat = 'repeat' | 'bracket' | 'comma';

export interface CreateHttpParamsOptions {
  arrayFormat?: ArrayFormat;
}

function normalizeParamValue(value: unknown): string {
  if (value instanceof Date) {
    return value.toISOString();
  }

  return String(value);
}

export function createHttpParams(obj: Record<string, unknown>, options: CreateHttpParamsOptions = {}): HttpParams {
  const { arrayFormat = 'repeat' } = options;
  let params = new HttpParams();

  for (const [key, value] of Object.entries(obj)) {
    if (value == null || value === '') {
      continue;
    }

    if (Array.isArray(value)) {
      const items = value.filter((v) => v != null && v !== '');
      if (!items.length) {
        continue;
      }

      if (arrayFormat === 'comma') {
        params = params.set(key, items.map(normalizeParamValue).join(','));
      } else if (arrayFormat === 'bracket') {
        for (const item of items) {
          params = params.append(`${key}[]`, normalizeParamValue(item));
        }
      } else {
        for (const item of items) {
          params = params.append(key, normalizeParamValue(item));
        }
      }
    } else {
      params = params.set(key, normalizeParamValue(value));
    }
  }

  return params;
}
